import { Col, Form, Input, Row } from 'antd';
import { useEffect, useState } from 'react';
import { AccidentHistoryFormComponent } from '../../Components/Accident_history_form/accident_history_form';
import { AsideComponent } from '../../Components/Aside/aside';
import AttachDocumentsForm from '../../Components/Attach_documents_form/attach_documents_form';
import { DeclarantFormComponent } from '../../Components/Declarant_form/declarant_form';
import { DescriptionAccidentFormComponent } from '../../Components/Description_accident_form/description_accident_form';
import { DriverFormComponent } from '../../Components/Driver_form/driver_form';
import PrevNextButtons from '../../Components/PrevNextButtons';
import { ThirdPartiesInvolvedFormComponent } from '../../Components/Third_parties_involved_form/third_parties_involved_form';
import { useFormContext } from '../../Context/DeclarationContext';
import './accident.scss';

type Props = {};

export const Accident = (props: Props) => {
  const { state, dispatch } = useFormContext();
  const [initialShowModal, setInitialShowModal] = useState(false);
  const [structureAdjunto, setStructureAdjunto] = useState({
    identityNumber: true,
    license: true,
    formFirma: true,
    documentOptional: true,
    vehiculoPropio: true,
    cuestionarioRobo: false,
    croquis: false,
  });

  useEffect(() => {
    console.log('adjunto', structureAdjunto);
  }, [structureAdjunto]);

  const [rutNotExist, setRutNotExist] = useState<boolean>(false);
  const [selectedForeignLicense, setSelectedForeignLicense] = useState(false);

  return (
    <div className="form_content">
      {/* steps */}
      <AsideComponent />

      <div className="form">
        {/* plate info */}
        <Row justify="center">
          <Col
            xs={24}
            style={{
              borderBottom: '1px solid #D9D9D9',
            }}
          >
            <h4 className="title">Identificación del vehículo siniestrado</h4>
            <Row gutter={[24, 24]} justify="center">
              <Col sm={6} xs={23}>
                <Form.Item label="Patente">
                  <Input disabled value={state.vehiclePatente?.deviceId} />
                </Form.Item>
              </Col>
              <Col sm={6} xs={23}>
                <Form.Item label="Marca">
                  <Input disabled value={state.vehiclePatente?.brand} />
                </Form.Item>
              </Col>
              <Col sm={6} xs={23}>
                <Form.Item label="Modelo">
                  <Input disabled value={state.vehiclePatente?.model} />
                </Form.Item>
              </Col>
              <Col sm={6} xs={23}>
                <Form.Item label="Año">
                  <Input disabled value={state.vehiclePatente?.year} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* forms */}

        {state.step === 0 && <DeclarantFormComponent rutNotExist={rutNotExist} setRutNotExist={setRutNotExist} />}
        {state.step === 1 && <DriverFormComponent selectedForeignLicense={selectedForeignLicense} setSelectedForeignLicense={setSelectedForeignLicense} />}
        {state.step === 2 && <AccidentHistoryFormComponent />}
        {state.step === 3 && <DescriptionAccidentFormComponent structureAdjunto={structureAdjunto} setStructureAdjunto={setStructureAdjunto} />}
        {state.step === 4 && <ThirdPartiesInvolvedFormComponent />}
        {state.step === 5 && (
          <AttachDocumentsForm structureAdjunto={structureAdjunto} showModal={initialShowModal} setShowModal={setInitialShowModal} />
        )}

        <PrevNextButtons currentStep={state.step ?? 0} showModal={initialShowModal} onSaveAndEndForm={setInitialShowModal} />
      </div>
    </div>
  );
};
